export const en = {
    'agency:': 'Agency representative:',
    'manager:': 'Manager:'
};
